export const LINE_HEIGHT = 18
export const VERTICAL_PADDING_MINI = 3
export const VERTICAL_PADDING_MEDIUM = 8
export const BORDER = 1
